module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "inputmessage mb-6 mr-sm-6 mb-sm-0",
    attrs: {
      "id": "inline-form-input-name",
      "required": "",
      "placeholder": "Enter name: what changed ?"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.saveMySurvey
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "surveyCreatorContainer"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae8bf4fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyCreator.vue
// module id = 374
// module chunks = 1